import React from 'react';
import { Route, Routes as RoutesComponent } from 'react-router-dom';
import { Auth } from './modules/auth/Auth';
import { Layout } from './shared/components/layout/Layout';
import { Session } from './modules/session/Session';
import { useAuth } from './modules/auth/auth-hook';
import { Loading } from './shared/components/Loading';
import { Logout } from './modules/auth/Logout';
import { DashboardTenant } from './modules/dashboard/DashboardTenant';
import { CustomSizes } from './shared/components/loading-types';
import { PlanViewLayout } from './modules/plans/PlanViewLayout';
import { Users } from './modules/user/Users';
import { RoleAuthorizationAdmin } from './modules/rbac/RoleAuthorization';
import { ReportsLayout } from './modules/reports/components/ReportsLayout';
import { ReportsView } from './modules/reports/ReportsView';
import { RBACPermissions } from './modules/rbac/rbac-types';
import { UserDetailsLayout } from './modules/user/components/UserDetailsLayout';
import { UserDetails } from './modules/user/UserDetails';
import { PlanDetailsLayout } from './modules/plans/components/PlanDetailsLayout';
import { PlanDetails } from './modules/plans/PlanDetails';
import { SettingLayoutNew } from './modules/setting/components/SettingLayoutNew';
import { SettingAccount } from './modules/setting/SettingAccount';
//import { SettingTenant } from './modules/setting/SettingTenant';
import { SettingUsers } from './modules/setting/SettingUsers';
//import { SettingInvitations } from './modules/setting/SettingInvitations';
//import { UserInvitations } from './modules/setting/user-invitations/UserInvitations';
import { Invitations } from './modules/setting/user-invitations/Invitations';
import { Comments } from './modules/comment/Comments';
import { Comment } from './modules/comment/Comment';
import { UsersLayout } from './modules/user/components/UsersLayout';
import { SubscriptionUsers } from './modules/subscription/SubscriptionUsers';
import { UserDetailsSubscription } from './modules/user/UserDetailsSubscription';
import { Divider } from '@mui/material';
import { UserExtraDetails } from './modules/user/UserExtraDetails';

export const Routes: React.FC = () => {
  const { loading } = useAuth();

  return loading ? (
    <Loading customSize={CustomSizes.lARGE} />
  ) : (
    <RoutesComponent>
      <Route path="/auth" element={<Auth />} />
      <Route path="/logout" element={<Logout />} />
      <Route
        path="*"
        element={
          <Session>
            <Invitations />
            <Layout>
              <RoutesComponent>
                <Route
                  path="/"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => <DashboardTenant />}
                      permission={RBACPermissions.DASHBOARD_TENANT}
                    />
                  }
                />
                <Route
                  path="/plans"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => <PlanViewLayout />}
                      permission={RBACPermissions.TENANT_PLANS}
                    />
                  }
                />
                <Route
                  path="/users"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => (
                        <UsersLayout>
                          <Users />
                        </UsersLayout>
                      )}
                      permission={RBACPermissions.SETTING_GLOBAL_USERS}
                    />
                  }
                />
                <Route
                  path="/users-subscribed"
                  element={
                    <UsersLayout>
                      <SubscriptionUsers />
                    </UsersLayout>
                  }
                />
                <Route
                  path="/comments"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => <Comments />}
                      permission={RBACPermissions.TENANT_COMMENTS}
                    />
                  }
                />
                <Route
                  path="/comments/:id"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => <Comment />}
                      permission={RBACPermissions.TENANT_COMMENTS}
                    />
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => (
                        <ReportsLayout>
                          <ReportsView />
                        </ReportsLayout>
                      )}
                      permission={RBACPermissions.REPORTS}
                    />
                  }
                />
                <Route
                  path="/users/:id"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => (
                        <UserDetailsLayout>
                          <>
                            <UserDetails />
                            <Divider sx={{paddingTop:'34px', marginBottom: '34px'}}/>
                            <UserExtraDetails />
                          </>
                        </UserDetailsLayout>
                      )}
                      permission={RBACPermissions.SETTING_GLOBAL_USERS}
                    />
                  }
                />
                <Route
                  path="/users/:id/subscriptions"
                  element={
                    <UserDetailsLayout>
                      <UserDetailsSubscription />
                    </UserDetailsLayout>
                  }
                />
                <Route
                  path="/plans/:id"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => (
                        <PlanDetailsLayout>
                          <PlanDetails />
                        </PlanDetailsLayout>
                      )}
                      permission={RBACPermissions.TENANT_PLANS}
                    />
                  }
                />
                <Route
                  path="/settings/account"
                  element={
                    <SettingLayoutNew>
                      <SettingAccount />
                    </SettingLayoutNew>
                  }
                />
                <Route
                  path="/settings/tenant-users"
                  element={
                    <RoleAuthorizationAdmin
                      render={() => (
                        <SettingLayoutNew>
                          <SettingUsers />
                        </SettingLayoutNew>
                      )}
                      permission={RBACPermissions.TENANT_USERS}
                    />
                  }
                />
              </RoutesComponent>
            </Layout>
          </Session>
        }
      />
    </RoutesComponent>
  );
};
